import { render } from "./B2bLoginPasswordFormGeneric.vue?vue&type=template&id=17810bec&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormGeneric.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormGeneric.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormGeneric.vue?vue&type=style&index=0&id=17810bec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17810bec"]])

export default __exports__